import React from "react";
import { CheckSquare, Tag, FileText } from "react-feather";
import { floatToCurrency } from "../../constants/validate";
import Loading from "../../components/Loading";
import { ClipLoader } from "react-spinners";
import Button from "../DesignSystem/Button";
import Spinner from "../Spinner";

import "./index.scss";

function PaymentCard({
  type,
  typePayment,
  total = 0,
  interestRate,
  numberInstallments = null,
  valueInstallments = null,
  withButton,
  isLoading = false,
  minHeight = "unset",
  handleClick,
  unpaid = false,
  downloadMinute = null,
  loading = false,
}) {
  const formattedTotalValue = floatToCurrency(Number(total));
  const formattedPartsValue =
    valueInstallments && floatToCurrency(Number(valueInstallments));
  // const paymentValue = floatToCurrency(Number(total))

  function renderClassName() {
    let currentClassName = "payment-card";

    if (type === "selected" || type === "review")
      currentClassName += " payment-card--selected";
    if (type === "toSelect") currentClassName += " payment-card--to-select";
    if (type === "proposalDebtor")
      currentClassName += " payment-card--proposal-debtor";

    return currentClassName;
  }

  if (isLoading) {
    return (
      <div className={renderClassName()} style={{ minHeight }}>
        <Spinner size={24} containerHeight="100%" />
      </div>
    );
  }

  function renderInstallments() {
    if (type === "proposalDebtor") {
      return (
        <div>
          <p className="payment-card__subtitle">+ {numberInstallments}x de</p>
          <p className="payment-card__value">{formattedPartsValue}</p>
        </div>
      );
    } else {
      return (
        <div>
          <p className="payment-card__value">
            Em até {numberInstallments}x de {formattedPartsValue}
          </p>
          <p className="payment-card__value-fees">
            Total com juros: {formattedTotalValue}
          </p>
        </div>
      );
    }
  }

  return (
    <div className={renderClassName()} style={{ minHeight }}>
      <header>
        <div className="payment-card__type">
          <div>
            {typePayment === "Parcelado" && <Tag size={20} />}
            {typePayment !== "Parcelado" && <CheckSquare size={20} />}
            <span>{typePayment}</span>
          </div>
        </div>
        {/* {(typePayment === "À vista" && interestRate) && <p>Juros {interestRate}%</p>} */}
      </header>
      <main>
        {typePayment === "À vista" && (
          <div>
            <p className="payment-card__value">{formattedTotalValue}</p>
          </div>
        )}
        {typePayment !== "À vista" && renderInstallments()}
      </main>
      {withButton && (
        <footer>
          <Button
            onClick={handleClick}
            size="small"
            contained
            style={{ width: "100%" }}
          >
            {typePayment === "À vista" && "Selecionar à vista"}
            {typePayment !== "À vista" && "Ver parcelas disponíveis"}
          </Button>
        </footer>
      )}
      {unpaid && (
        <div className="payment-card__download-button" onClick={downloadMinute}>
          {loading ? <ClipLoader size={18} color="white" /> : <FileText />}
        </div>
      )}
    </div>
  );
}

export default PaymentCard;
